import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { formStyle } from '../../TransitionStyles';

AutocompleteInput.propTypes = {
    fieldName: PropTypes.string,
    fieldAttributes: PropTypes.object,
    options: PropTypes.array,
};

export default function AutocompleteInput({ fieldName, fieldAttributes, options }) {
    const { control } = useFormContext();
    const { field, fieldState } = useController({ name: fieldName, control });
    const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

    const selectedOption = options?.find((opt) => String(opt.value) === String(field.value)) || null;

    return (
        <Autocomplete
            key={field.id}
            onKeyDown={(e) => {
                if (e.key === 'Enter') e.preventDefault();
            }}
            options={options ?? []}
            getOptionLabel={(opt) => opt?.label || ''}
            value={selectedOption}
            disabled={!fieldAttributes.isEditable || isCanceled}
            onChange={(_, value) => field.onChange(value ? value.value : null)}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(paramsInput) => (
                <TextField
                    {...paramsInput}
                    inputRef={field.ref}
                    fullWidth
                    size="small"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    sx={formStyle}
                    autoComplete="off"
                    placeholder={fieldAttributes.placeholder}
                />
            )}
        />
    );
}